import { Routes } from '@angular/router';
import {authRoutes} from './modules/auth/auth.routes';
import {panelRoute} from './modules/panel/panel.route';
import { viewsRoutes } from './modules/views/views.route';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => authRoutes
  },
  {
    path: '',
    loadChildren: () => panelRoute,
  },
  {
    path: '',
    loadChildren: () => viewsRoutes
  },
  {
    path: '**',
    redirectTo: 'not-found',
  }
];
